var React = require('react');

function BriefCase (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2","y":"7","width":"20","height":"14","rx":"2","ry":"2","key":0}),React.createElement("path",{"d":"M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16","key":1})]);
}

BriefCase.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-briefcase"};

module.exports = BriefCase;

BriefCase.default = BriefCase;
